// extracted by mini-css-extract-plugin
export default {"titleButton":"style_titleButton__lSK9V","progressWrapper":"style_progressWrapper__pl-qI","titleWrapper":"style_titleWrapper__xW7Bc","borderedTable":"style_borderedTable__DEiu4"};